import "./MetalFabricationAndStamping.module.css";
import Header from "@/reusable_sections/Header";
import FabricacaoMetal from "./sections/FabricacaoMetal";
import Processes from "./sections/Processes";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function MetalFabricationAndStampingPage() {
  return <div>
      <Header />
      <FabricacaoMetal />
      <Processes />
      <Cta />
      <Footer />
    </div>;
}